import React from 'react';
import ChevronRight from '../assets/images/Chevron_Right_MD.png'; // Adjust path as needed

export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
  active?: boolean;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => (
  <nav
    aria-label="breadcrumb"
    style={{
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Helvetica Neue, Arial, sans-serif',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      letterSpacing: 0,
      color: '#888',
      marginBottom: 8,
    }}
  >
    {items.map((item, idx) => (
      <React.Fragment key={idx}>
        <span
          style={{
            color: item.active ? '#2196f3' : '#888',
            cursor: item.onClick && !item.active ? 'pointer' : 'default',
            fontWeight: 400,
            textDecoration: item.onClick && !item.active ? 'underline' : 'none',
            transition: 'color 0.2s',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit',
          }}
          onClick={item.onClick && !item.active ? item.onClick : undefined}
        >
          {item.label}
        </span>
        {idx < items.length - 1 && (
          <img
            src={ChevronRight}
            alt=">"
            style={{ margin: '0 8px', width: 18, height: 18, verticalAlign: 'middle' }}
          />
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumbs; 